import script from "./SecurityInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityInformation.vue?vue&type=script&setup=true&lang=js"

import "./SecurityInformation.vue?vue&type=style&index=0&id=56ce7b70&scoped=true&lang=css"

import exportComponent from "E:\\GCM3\\Demo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ce7b70"]])

export default __exports__